import React, { useState } from 'react';
import AddShippingDocs from './addShippingDocuments';
import { docsTypes } from '../../../initial-values';
import { getDocumentName } from '../../../utils/helper';
import delIcon from '../../../assets/icons/new_icon/delete-2.svg';
import NoTableData from '../../global-components/NoTableData';

interface Props {
  documents: any;
  setDocuments: any;
}
function UploadDocField({ documents, setDocuments }: Props) {
  const [showAddModal, setShowAddModal] = useState<any>(false);
  const handleRemove = (index: number) => {
    const updatedDocuments = [...documents];
    updatedDocuments.splice(index, 1);
    setDocuments(updatedDocuments);
  };
  return (
    <div className='ubbe-card mt-4'>
      <div className='ubbe-card-header d-flex justify-content-between px-3'>
        <h5
          className='mb-0 GlobalBoxHead'
          data-bs-toggle='tooltip'
          data-bs-placement='bottom'
          data-bs-html='true'
          title='Please click on the upload document button for more information'
        >
          Documents
        </h5>
        <button
          type='button'
          className='btn btn-ubbe-white'
          onClick={() => {
            setShowAddModal(true);
          }}
        >
          <span className='me-1'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M15.1579 6.552H12.7242C10.7284 6.552 9.10316 5.008 9.10316 3.112V0.8C9.10316 0.36 8.72421 0 8.26105 0H4.69053C2.09684 0 0 1.6 0 4.456V11.544C0 14.4 2.09684 16 4.69053 16H11.3095C13.9032 16 16 14.4 16 11.544V7.352C16 6.912 15.6211 6.552 15.1579 6.552ZM7.60421 9.224C7.47789 9.344 7.31789 9.4 7.15789 9.4C6.99789 9.4 6.83789 9.344 6.71158 9.224L6.10526 8.648V12C6.10526 12.328 5.81895 12.6 5.47368 12.6C5.12842 12.6 4.84211 12.328 4.84211 12V8.648L4.23579 9.224C3.99158 9.456 3.58737 9.456 3.34316 9.224C3.09895 8.992 3.09895 8.608 3.34316 8.376L5.02737 6.776C5.08632 6.728 5.14526 6.688 5.21263 6.656C5.22947 6.648 5.25474 6.64 5.27158 6.632C5.32211 6.616 5.37263 6.608 5.43158 6.6C5.45684 6.6 5.47368 6.6 5.49895 6.6C5.56632 6.6 5.63368 6.616 5.70105 6.64C5.70947 6.64 5.70947 6.64 5.71789 6.64C5.78526 6.664 5.85263 6.712 5.90316 6.76C5.91158 6.768 5.92 6.768 5.92 6.776L7.60421 8.376C7.84842 8.608 7.84842 8.992 7.60421 9.224Z'
                fill='#251163'
              />
              <path
                d='M12.5736 5.4476C13.3736 5.4556 14.4852 5.4556 15.4368 5.4556C15.9168 5.4556 16.1694 4.9196 15.8325 4.5996C14.6199 3.4396 12.4473 1.3516 11.201 0.167604C10.8557 -0.160396 10.2578 0.0636039 10.2578 0.519604V3.3116C10.2578 4.4796 11.302 5.4476 12.5736 5.4476Z'
                fill='#251163'
              />
            </svg>
          </span>
          Upload
        </button>
      </div>
      <div className='card-body p-4'>
        <table className='table mb_0 ' id='document_table'>
          <thead className='ubbe-table-header'>
            <tr>
              <th
                scope='col'
                className='text-start align-middle ubbe-table-heading-text'
                style={{ width: '25%' }}
              >
                Document Type
              </th>
              <th
                scope='col'
                className='text-start align-middle ubbe-table-heading-text'
                style={{ width: '42%' }}
              >
                File
              </th>
              <th
                scope='col'
                className='text-center align-middle ubbe-table-heading-text'
                style={{ width: '10%' }}
              >
                Delete
              </th>
            </tr>
          </thead>
          <tbody id='shipment_document_rows'>
            {documents && documents.length > 0 ? (
              documents.map((item: any, index: number) => (
                <tr data-document={`${JSON.stringify(documents)}`}>
                  <td className={'py-3 align-middle text-start'}>
                    {getDocumentName(docsTypes, item.type)}
                  </td>
                  <td className={'py-3 align-middle text-start'}>
                    {item?.file_name}
                  </td>

                  <td className='text-center align-middle py-3'>
                    <button
                      className='btn-ubbe-no-style'
                      onClick={() => {
                        handleRemove(index);
                      }}
                    >
                      <img
                        alt='delete-icon'
                        src={delIcon}
                        className='packageBoxIcon'
                        style={{
                          backgroundColor: 'rgba(252, 0, 0, 0.10)',
                        }}
                      />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className='w-full'>
                <td colSpan={4}>
                  <NoTableData message='No Documents Added Yet! Click on Upload.' />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showAddModal && (
        <AddShippingDocs
          setShowAddShipmentDocModal={setShowAddModal}
          setDocArray={setDocuments}
          docArray={documents}
        />
      )}
    </div>
  );
}

export default UploadDocField;
